import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { apiService } from "../services/api";
import { useSession } from "./useSession";

export interface ModuleAccess {
  dashboard: boolean;
  tariff_calculator: boolean;
  tariff_chat: boolean;
  risk_prediction: boolean;
  route_optimization: boolean;
  admin_panel: boolean;
}

const moduleAccessQueryKey = ["admin", "me", "modules"] as const;

type UseModuleAccessOptions = Pick<
  UseQueryOptions<ModuleAccess, Error, ModuleAccess, typeof moduleAccessQueryKey>,
  "enabled" | "staleTime" | "retry"
>;

export function useModuleAccess(options?: UseModuleAccessOptions) {
  const { isReady, isAuthenticated } = useSession();
  const isAuthEnabled = isReady && isAuthenticated;

  return useQuery<ModuleAccess, Error, ModuleAccess, typeof moduleAccessQueryKey>({
    queryKey: moduleAccessQueryKey,
    queryFn: async () => {
      const res = await apiService.getMyModules();
      // Fallback to empty object if backend does not return modules
      return (res.data.modules || {}) as ModuleAccess;
    },
    enabled: isAuthEnabled && (options?.enabled ?? true),
    staleTime: options?.staleTime ?? 60_000,
    retry: options?.retry ?? 1,
  });
}

